import React, { useEffect, useRef } from "react";
import markupManual from "./markupManual";

const ModalInfo: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const modalRef = useRef<any>(null);

  useEffect(() => {
    const clickOutside = (e: any) => {
      if (!modalRef?.current || modalRef?.current?.contains(e.target)) {
        return;
      }
      onClose();
    };

    window.addEventListener("click", clickOutside);

    return () => {
      window.removeEventListener("click", clickOutside);
    };
  }, [modalRef, onClose]);

  return (
    <div className="modal-info">
      <div ref={modalRef} className="modal-info-content">
        <div className="close-modal">
          <span onClick={onClose}>&times;</span>
        </div>
        <p>
          Bone marrow lesions and subchondral cysts will be scored from 0 to 3:
          <br />
          <br />
          0 - absent
          <br />
          1 - mild: &lt;33% of subregional volume involved
          <br />
          2 - moderate: 33-66% of subregional volume involved
          <br />
          3 - severe: &gt;66% of subregional volume involved
          <br />
          <br />
          <b>Synovitis</b>
          <br />
          Synovitis will be scored from 0 to 2 according to the synovial
          thickness (enhancement).
          <br />
          Thickness of 2- 4 mm is considered as grade 1, thickness - 4 mm as
          grade 2 synovitis.
          <br />
          Single grade 0, 1, 2 (overall joint assessment)
          <br />
          <br />
          Coronal and axial T1w fat-suppressed contrast-enhanced MR images are
          used to evaluate the presence of synovitis.
          <br />
          Synovitis is scored at four defined locations. The coronal plane is
          necessary for the assessment of the medial (MS) and lateral (LS)
          locations and the axial plane for the anterior (AS) and posterior (PS)
          locations of synovitis scoring. Scoring will be performed at the level
          of the femoral headeneck-junction
          <br />
          <br />
          <b>Cartilage</b>
          <br />
          Cartilage integrity or damage will be assessed using a single score
          that is based on a percentage of affected area of any given subregion
          <br />
          focal defects are differentiated from more diffuse damage. Further
          depth of cartilage lesion is taken into account. Any subregion is
          scored according to worst grade within subregion. Cartilage will be
          scored from 0 to 4:
          <br />
          0 - normal cartilage
          <br />
          1 - focal partial thickness defect (≤25% of subregional area affected)
          <br />
          2 - focal full thickness defect (≤25% of subregional area affected)
          <br />
          3 - several partial thickness defects or single but larger superficial
          defect (&gt;25% of subregional area affected)
          <br />4 - several large full thickness defects or single full
          thickness defect (&gt;25% of subregional area affected).
        </p>
      </div>
    </div>
  );
};

export default ModalInfo;
